import 'arrive'
import Glide from '@glidejs/glide'

document.arrive('.block-cards-slider', {existing:true}, function(){
  let sliders = document.querySelectorAll('.glide')
  const sliderTitle = document.querySelector('.block-cards-slider__title')
  const offsetLeft = sliderTitle.getBoundingClientRect().left

  

  sliders.forEach(slide => {
    new Glide( slide,{
      type: "slider",
      startAt: 0,
      perView: 3,
      gap: 60,
      bound: true,
      perTouch: 1,
      animationDuration: 500,
      peek: {
        before: offsetLeft,
        after: 170
      },
      breakpoints: {
        1080: {
          perView: 3,
          gap: 30
        },
        920: {
          perView: 2,
          gap: 30
        },
        640: {
          perView: 1,
          gap: 25,
          peek: {
            before: offsetLeft,
            after: 80
          }
        }
      }
    }).mount()

  });
  


})